import React, { useState, useEffect } from 'react';
import { Box, Button, ListItem, Typography, Paper, ListItemAvatar, Avatar, List } from '@material-ui/core';
import { useTranslate, useDataProvider } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { Folder, Description } from '@material-ui/icons';
import Breadcrumbs from './file-breadcrumbs';
import CustomPopoverArrow from '../CustomizedUIs/CustomPopoverArrow';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        width: 300,
        height: 300,
        padding: theme.spacing(1),
        overflow: 'hidden'
    },
    titlePopover: {
        fontFamily: "UniviaPro",
        fontSize: "13px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.25,
        letterSpacing: "0.13px",
    }, btnCancel: {
        fontFamily: "UniviaPro",
        fontSize: "11px",
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.2,
        letterSpacing: "normal",

    }
}));

function SystemFolderPopOver({ popupState, onSave, state }) {
    const dataProvider = useDataProvider();
    const translate = useTranslate();
    const classes = useStyles();
    const [category, setCategory] = useState(null);
    const { selectedItems, itemSelectedPopup } = useSelector(state => state.file_manager);

    const getCategory = (id) => {
        dataProvider('GET_LIST', 'categories', {
            filter: { id },
            pagination: {},
            sort: {}
        }).then(({ data }) => {
            setCategory(data);
        }).catch(error => {
            console.error('Get list error:', error);
        });
    }

    const isAllFolder = () => {
        if (selectedItems.length === 0) {
            if (itemSelectedPopup && itemSelectedPopup.type !== "Folder") {
                return false
            } else {
                return true
            }
        } else {
            for (let i = 0; i < selectedItems.length; i++) {
                if (selectedItems[i].type !== "Folder") {
                    return false
                }
            }
            return true
        }


    }

    const isDisablePasteBtn = () => {
        if (!category) return false;
        if (category.level === -1) return false;
        if (category.level === 1) return true;
        if (category.level === 2 && isAllFolder()) return false;
        return true;
    }


    const onClick = (item) => {
        const itemExist = selectedItems.find(selectedItem => selectedItem.id === item.id);
        if (item.type === 'Folder' && !itemExist) {
            getCategory(item.id);
        }
    }

    const getRootCategoryId = () => {
        dataProvider('GET_ONE', 'category/root-id').then(({ data }) => {
            getCategory(data);
        }).catch(error => {
            console.error('Get list error:', error);
        });
    }

    const onBackClick = () => {
        const { path } = category;
        if (path.length === 1) {
            popupState.close();
        } else {
            const { id } = path[path.length - 2];
            getCategory(id);
        }
    }

    useEffect(() => {
        getRootCategoryId();
    }, []);

    let categories = category ? category.categories : [];
    let userData = JSON.parse(localStorage.getItem('userData'))
    if (categories && categories.length > 0) {
        if (userData.permission.name !== 'Sysadmin' && userData.permission.name !== 'Admin' && userData.permission.name !== 'Superuser') {
            categories.map((item, index) => {
                if (item.level === -1 && item.name === 'System files')
                    categories.splice(index, 1)
            })
        }
    }

    return (
        <CustomPopoverArrow
            zIndex={1600}
            placement='right'
            popupState={popupState}
        >
            <Box className={classes.container} component={Paper}>
                <Breadcrumbs
                    small
                    path={category && category.path}
                    onBackClick={onBackClick}
                    getCategory={getCategory}
                />
                <List style={{ flex: 1, overflow: 'auto' }}>
                    {
                        categories.map(item =>
                            <ListItem button onClick={() => onClick(item)} key={item.id + ''}>
                                <ListItemAvatar>
                                    <Avatar>
                                        {item.type === 'Folder' ? <Folder /> : <Description />}
                                    </Avatar>
                                </ListItemAvatar>
                                {/* <ListItemText primary={item.name} /> */}
                                <Typography className={classes.titlePopover}>{item.name}</Typography>
                            </ListItem>
                        )
                    }
                </List>
                <Box display='flex' justifyContent='flex-end'>
                    <Button
                        className={classes.btnCancel}
                        color='primary'
                        type='button'
                        style={{ marginRight: '1rem' }}
                        onClick={() => {
                            popupState.close();
                            getRootCategoryId();
                        }}
                    >{translate('pos.common.cancel')}</Button>
                    <Button
                        className={classes.btnCancel}
                        color='primary'
                        type='button'
                        style={{ marginRight: '1rem' }}
                        disabled={isDisablePasteBtn()}
                        onClick={() => {
                            getRootCategoryId();
                            onSave(category.id, category.name);
                        }}
                    >{state === 'COPY' ? translate('pos.common.paste') : translate('pos.common.move')}</Button>
                </Box>
            </Box>
        </CustomPopoverArrow >
    );
}

SystemFolderPopOver.propTypes = {
    anchorEl: PropTypes.object,
    state: PropTypes.string,
    onSave: PropTypes.func.isRequired,
};

export default SystemFolderPopOver;
